<ngx-extended-pdf-viewer
  [src]="url"
  height="80vh"
  [authorization]="token"
  [language]="language"
  [filenameForDownload]="fileName"
  [showSidebarButton]="false"
  [showPagingButtons]="true"
  [showPresentationModeButton]="false"
  [showOpenFileButton]="false"
  [showBookmarkButton]="false"
  [showSecondaryToolbarButton]="true"
  [showRotateButton]="false"
  [showHandToolButton]="false"
  [showScrollingButton]="false"
  [showSpreadButton]="false"
  [showPropertiesButton]="false"
  [sidebarVisible]="false">
</ngx-extended-pdf-viewer>


